import React from 'react';

import { Channel } from 'src/public/js/siteUtilities';

import ChevronIcon from 'shared/components/common/carousel/ChevronIcon';
import Link from 'shared/components/common/link';
import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext';

import { DEFAULT_COLORS } from 'public/components/default_template/meta/StyleMeta';
import { CartItems } from 'public/components/default_template/online_ordering/cart/Cart';
import { getCheckoutEligibleItems } from 'public/components/default_template/online_ordering/cart/cartUtils';
import CheckoutSection from 'public/components/default_template/online_ordering/checkout/CheckoutSection';
import { useCart } from 'public/components/online_ordering/CartContext';


const OrderSection = () => {
  const { cart, channel } = useCart();
  const { orderPath, ecommPath } = useRestaurantRoutes();
  const numItems = getCheckoutEligibleItems(cart)?.length || 0;

  return (
    <CheckoutSection title={`Order details (${numItems})`} collapsible>
      <div className="cartOrder expandableSection">
        <CartItems editable />
        <Link href={channel === Channel.ECOMM ? ecommPath : orderPath}>
          <div className="addItemsButton" role="button" >
            <ChevronIcon color={DEFAULT_COLORS.text as string} />
            <span>Add more items</span>
          </div>
        </Link>
      </div>
    </CheckoutSection>
  );
};
export default OrderSection;
